module.exports = __webpack_public_path__ + "images/a28f5bf8897de8584b515ec239aac0f1.png";